import React from "react";

interface CodeBlockProps {
  content: string;
  variant?: "raw" | "formatted";
  className?: string;
  maxHeight?: string;
}

/**
 * A component for displaying code or formatted text in a scrollable container.
 * Supports raw (plain) and formatted (monospace) display variants.
 */
export function CodeBlock({
  content,
  variant = "formatted",
  className = "",
  maxHeight = "max-h-96",
}: CodeBlockProps) {
  return (
    <div className={`bg-muted p-4 rounded-lg overflow-auto ${maxHeight} ${className}`}>
      {variant === "raw" ? (
        <pre className="text-xs text-foreground whitespace-pre-wrap">{content}</pre>
      ) : (
        <div className="text-sm text-foreground">
          <pre className="whitespace-pre-wrap font-mono text-xs">{content}</pre>
        </div>
      )}
    </div>
  );
}
